
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class IcStockDisassembleDialog extends Serenity.EntityDialog<IcStockDisassembleRow, any> {
        protected getFormKey() { return IcStockDisassembleForm.formKey; }
        protected getIdProperty() { return IcStockDisassembleRow.idProperty; }
        protected getLocalTextPrefix() { return IcStockDisassembleRow.localTextPrefix; }
        protected getNameProperty() { return IcStockDisassembleRow.nameProperty; }
        protected getService() { return IcStockDisassembleService.baseUrl; }
        protected getDeletePermission() { return IcStockDisassembleRow.deletePermission; }
        protected getInsertPermission() { return IcStockDisassembleRow.insertPermission; }
        protected getUpdatePermission() { return IcStockDisassembleRow.updatePermission; }

        protected form = new IcStockDisassembleForm(this.idPrefix);

        constructor() {
            super();
            this.form = new IcStockDisassembleForm(this.idPrefix);
            (this.form.IcStockDisassembleDtList.view as any).onDataChanged.subscribe(() => {
                let self = this;
                //ui-state-default slick-footerrow-column l0 r0 frozen
                self.element.find(".ui-state-default.slick-footerrow-column.l0.r0.frozen").html("รวม");
            });

            this.form.RefDocNo1.change(e => {
                var skucode = Q.toId(this.form.RefDocNo1.value);                
               
                var orderNo = this.form.RefDocNo1.value;

                if(!Q.isEmptyOrNull(orderNo)){

                    this.form.SetItemCode.value = (IcStockSetAssembleRow.getLookup().itemById[orderNo].SetItemCode)  
                    this.form.SetQty.value = (IcStockSetAssembleRow.getLookup().itemById[orderNo].SetQty)  
                    
                    this.form.IcStockDisassembleDtList.SetItemCode = this.form.RefDocNo1.value;
                        // const getPO = Q.first(this.form.SetItemCode.items, x=> (x.source as Product.PsSetItemRow).SetItemCode == orderNo);
                        // this.setPurOrderDetails(getPO.source);
                    this.form.IcStockDisassembleDtList.refresh();
                }else{
                    this.form.IcStockDisassembleDtList.clearDataGrid();
                }
                // this.form.SetQty.value =1
            
            });

            this.form.SetQty.changeSelect2(e => {
                var orderNo = this.form.SetQty.value;
                console.log("order: " + orderNo);
                var orderNo0 = this.form.RefDocNo1.value;
                if(!Q.isEmptyOrNull(orderNo0)){
                        let set = (IcStockSetAssembleRow.getLookup().itemById[orderNo0].SetQty)  
                        let use = (IcStockSetAssembleRow.getLookup().itemById[orderNo0].QtyUse)
                        console.log("set:"+set+".use:"+use)

                        var checkmax = set - use
                if(orderNo > 0){
                    if( orderNo < checkmax ){
                    this.form.IcStockDisassembleDtList.QtySetItem = this.form.SetQty.value;
                        // const getPO = Q.first(this.form.SetItemCode.items, x=> (x.source as Product.PsSetItemRow).SetItemCode == orderNo);
                        // this.setPurOrderDetails(getPO.source);
                    this.form.IcStockDisassembleDtList.refresh();
                }else{
                    Q.warning("เพิ่ม จำนวนชุดได้เท่ากับ "+checkmax + " ไม่สามารถมากกว่าจำนวนเดิมได้")
                    this.form.SetQty.value = checkmax
                }
                }else{
                    this.form.IcStockDisassembleDtList.clearDataGrid();
                }}
            
            });


        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            if (this.isEditMode) {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
               

                


                let newSaveBtn: Serenity.ToolButton =
                {
                    title: "บันทึกเอกสาร",
                    hint: "Save",
                    separator: false,
                    cssClass: "button-save",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {

                        var self = this;
                        this.form.WhsItem.element.toggleClass("required", true);
                        this.form.WhsSet.element.toggleClass("required", true);
                        this.form.SetItemCode.element.toggleClass("required", true);

                        //ถ้าแก้เรื่องการใช้งานบนหน้าแล้วข้อมูลDt ขาอัพเดตไม่นำตัวใหม่ไปใช้งานได้แล้วมาปิด2บรรทัดนี้
                        // if(this.isNew()){
                        // this.form.IcStockDisassembleDtList.value = null
                    // }
                        this.form.CallAssemDocFg.value = 1; // ใช้งานtriggerเชคซ้ำ  refที่ประกอบแล้ว
                        if (this.validateForm() && this.validateBeforeSave()) {
                            var options = this.getSaveOptions((response) => {

                                if (this.isEditMode()) {
                                    var id1 = response.EntityId;
                                    if (id1 == null) {
                                        id1 = this.get_entityId();
                                    }
                                    //this.loadById(id1);
                                    this.dialogClose();
                                }
                                else {
                                    // this.loadById(response.EntityId);
                                    this.dialogClose();
                                }

                                this.showSaveSuccessMessage(response);


                            });

                            options.onError = function (response) {
                                if (response.Error.Message == "Can't save record. There is another record with the same เลขที่เอกสาร value!") {
                                    //Q.alert(response.Error.Message = "เลขที่เอกสารถูกใช้งานแล้ว ระบบจำทำการบรับเลขที่เอกสาร โปรดทำการบันทึกอีกครั้ง");
                                    var s = self.form.SysDocNo.value
                                    var f = s.substring(0, 9)
                                    GeniuzPOS.Inventory.IcStockDisassembleService.GetNextNumber({
                                        Prefix: f,
                                        Length: 15
                                    }, response => {

                                        self.form.SysDocNo.value = response.Serial;

                                    });                                    


                                } else { Q.alert(response.Error.Message); }



                            }

                            Q.serviceCall(options);
                        } else {
                            this.save((response) => {
                                this.dialogClose();
                            });


                        }

                    }
                };
                buttons.push(newSaveBtn);

                let newDeleteBtn: Serenity.ToolButton =
                {
                    title: "ลบเอกสาร'",
                    hint: "Delete",
                    separator: false,
                    cssClass: "delete-button",
                    icon: "fa fa-save",
                    hotkey: 'alt+x',
                    onClick: (e) => {
                        Q.confirm('ยืนยันการลบเอกสาร', () => {
                            this.form.CancelFg.value = "2";
                            this.save((response) => {
                                this.dialogClose();
                            });
                        });
                    }
                };
                buttons.push(newDeleteBtn);


            }
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();

                    },
                }
            );

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            //this.form.IcStockDisassembleDtList.myPassValue = this.entity.SysDocNo

            if (this.isNew()) {
                this.getNextNumber();
                //this.toolbar.findButton('button-save-post').hide();
                this.toolbar.findButton('delete-button').hide();


            }


            //$('<a class="inplace-button inplace-create"><b><\/b><\/a>').insertAfter(this.form.SetItemCode.element).click(() => this.myFunction()); //ต้นฉบับ

            // this.toolbar.findButton('cal-qtysetItem').insertAfter(this.form.SetQty.element)  // <======================


            ////----
            let self = this;
            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".panel-titlebar").length == 1) {
                            // self.element.find(".panel-titlebar").html("");
                            // self.element.find(".panel-titlebar-text").html("");
                            self.element.find(".panel-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        // if (self.element.parent().find(".panel-titlebar").length == 1) {
                        //     // self.element.parent().find(".panel-titlebar").html("");
                        //     // self.element.parent().find(".panel-titlebar-text").html("");
                        //     self.element.parent().find(".panel-titlebar-close").html("");
                        // }
                        // else {
                        //     changeTitle();
                        // }
                    }
                }, 100);
            })();
            if (this.entity.PostFg == 1 || this.entity.PostFg == 2 || this.entity.CancelFg == 1) {
                this.toolbar.findButton('cal-qtysetItem').hide();
                //this.toolbar.findButton('genarate-po-button').hide();
                this.toolbar.findButton('delete-button').hide();
                this.toolbar.findButton('button-save').hide();
                this.toolbar.findButton('apply-changes-button').toggleClass('disabled', false);
                //Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
                // this.applyChangesButton.toggleClass('disabled', true);
                // this.saveAndCloseButton.toggleClass('disabled', true);
                this.deleteButton.toggleClass('disabled', true);
                this.form.IcStockDisassembleDtList.set_readOnly(true);
            } else {
                this.toolbar.findButton('apply-changes-button').hide();

            }
        }


        // protected getSaveEntity(): IcStockDisassembleRow {
        //     let entity = super.getSaveEntity();

        //     return entity;
        // }

        private getNextNumber() {
            var val = Q.trimToNull(this.form.SysDocNo.value);



            if (!val || val.length <= 3) {
                var someDate = new Date();
                var dd = someDate.getDate();
                var mm = someDate.getMonth() + 1;
                var myRow = 0;
                var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
                console.log('User Id : ' + userId.ShopId);
                try {
                    var userRole = Q.first(Administration.UserRoleRow.getLookup().items, x => x.UserId == userId.UserId);

                    if (userRole != null) {
                        myRow = userRole.RoleId;
                    }
                    if (userRole != null || userRole.RoleId.valueOf) {
                        myRow = userRole.RoleId;
                    }
                    if (myRow == 1) {
                        //(this.form.SlmnCode.element as any).select2(userId.SlmnCode);
                    }
                } catch {

                }

                var y = someDate.getFullYear();
                var mo = "";
                var ddd = "";

                if (mm < 10) {
                    mo = '0' + mm;

                } else {
                    mo = mm.toString();
                }

                if (dd < 10) {
                    //ddd = '0' + dd;
                    ddd = '';

                } else {
                    //ddd = dd.toString();
                    ddd = '';
                }

                var someFormattedDate = y.toString().substr(2, 2);

                var docprefix = Q.tryFirst(Product.CsDocTypeRow.getLookup().items, x => x.DocType == "40").DocPrefix;
                var prefix = docprefix + userId.ShopId + someFormattedDate + mo + ddd;
                GeniuzPOS.Inventory.IcStockDisassembleService.GetNextNumber({
                    Prefix: prefix,
                    Length: 15
                }, response => {

                    this.form.SysDocNo.value = response.Serial;
                    this.form.DocDate.element.focus();
                    // return true;
                });
                // return false;
            }

        }




    }
}